// KDANKGM05050_近代化資金契約書内容確認
// KDANKGM05050_近代化資金契約書内容確認（連帯債務者等）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Heading from '../../molecules/Heading';
import SignInfo from '../../templates/SignInfo';
import { KeyValue } from '../../types/KeyValue';
import { mp_flg as mp_flg_value } from '../../Const';
import { GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import { StepNavigation as StepType } from '../../types/Template';
import ContractContentConfirmHeadingArea from './ContractContentConfirmHeadingArea';
import ShowModernizationFundButton from '../../molecules/ShowModernizationFundButton';
import FooterConfirmationOfContractContents from '../../organisms/FooterConfirmationOfContractContents';
import ShowBusinessImprovementFinancingPlanButton from '../../molecules/ShowBusinessImprovementFinancingPlanButton';
interface Props {
  reception_id: number;
  status_code: number;
  reception_cd: string;
  step_navigation: StepType;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  sign_info: KeyValue[];
  guarantor_info: GuarantorInfo;
  display_status: boolean;
  is_signed: boolean;
  is_loading: boolean;
  is_checked_contract_document: boolean;
  mp_flg: number; // 借入申込希望書兼経営改善資金計画書フラグ
  handleDecline: () => void;
  handleExecution: () => void;
  info_notice: string;
  is_active_decline_btn: boolean;
  is_signer: boolean;
}

const ModernisationFundingContractContentConfirm: React.FC<Props> = ({
  label,
  mp_flg,
  sign_info,
  is_signed,
  is_loading,
  guide_text,
  status_name,
  status_code,
  reception_id,
  reception_cd,
  guarantor_info,
  display_status,
  step_navigation,
  display_reception_cd,
  is_checked_contract_document,
  handleDecline,
  handleExecution,
  info_notice,
  is_active_decline_btn,
  is_signer,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />

      <ContractContentConfirmHeadingArea
        status_code={status_code}
        guarantor_info={guarantor_info}
        is_signed={is_signed}
      />

      {/* お申込情報 */}
      <Heading size="m" label="お申込情報" />
      {/* 書類提出のみの場合は『借入申込希望書兼経営改善資金計画書』ボタンを非表示 */}
      {mp_flg !== mp_flg_value.none && (
        <ShowBusinessImprovementFinancingPlanButton status_code={status_code} />
      )}

      {/* 『借入申込書』ボタン表示 */}
      <ShowModernizationFundButton status_code={status_code} />

      <SignInfo sign_info={sign_info} />
      <FooterConfirmationOfContractContents
        status={status_code}
        is_staff={false}
        is_verification={true}
        reception_id={reception_id}
        is_signed={is_signed}
        handleDecline={handleDecline}
        handleExecution={handleExecution}
        is_checked_contract_document={is_checked_contract_document}
        info_notice={info_notice}
        is_active_decline_btn={is_active_decline_btn}
        is_signer={is_signer}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ModernisationFundingContractContentConfirm;
